import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@Src/app/hooks';
import { AppRouteURL } from '@Constants/app-route-url.constant';
import { getUserDetails } from '@Features/UserProfile/Services/UserProfile.sevice';
import { USE_MOCK_DATA, getMockUserDetails } from '@Src/mocks/subscriptionMockData';

export const useSubscriptionAccess = () => {
    const navigate = useNavigate();
    const loginData = useAppSelector((state: any) => state.login);
    const isLoggedIn = loginData?.isLoggedIn;

    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [hasSubscriptionAccess, setHasSubscriptionAccess] = useState(false);

    useEffect(() => {
        checkSubscriptionAccess();
    }, []);

    const checkSubscriptionAccess = async () => {
        if (!isLoggedIn) {
            navigate(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY);
            return;
        }

        try {
            setIsCheckingAccess(true);
            const response: any = USE_MOCK_DATA
                ? await getMockUserDetails()
                : await getUserDetails();

            if (response?.ResponseType === 'SUCCESS' && response?.data?.[0]) {
                const userDetails = response.data[0];
                const {
                    last_student_subscription_rel_id,
                    Student_sub_ShowAnalytics,
                    Student_sub_EndDate,
                    Institute_sub_PlanName,
                    Institute_sub_ShowAnalytics,
                    Institute_sub_EndDate
                } = userDetails;

                let hasAccess = false;
                const currentDate = new Date();
            

                

                // Check student subscription
                if (last_student_subscription_rel_id) {
                    const isShowAnalytics = Student_sub_ShowAnalytics === 1;
                    const isExpired = Student_sub_EndDate ? new Date(Student_sub_EndDate).setHours(0,0,0,0) < currentDate.setHours(0,0,0,0) : false;
                    hasAccess = isShowAnalytics && !isExpired;
                    
                }
                // Check institute subscription
                else if (Institute_sub_PlanName) {
                    const isShowAnalytics = Institute_sub_ShowAnalytics === 1;
                    const isExpired = Institute_sub_EndDate ? new Date(Institute_sub_EndDate).setHours(0,0,0,0) < currentDate.setHours(0,0,0,0) : false;
                    hasAccess = isShowAnalytics && !isExpired;
                }





                setHasSubscriptionAccess(hasAccess);

            } else {
                navigate(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY);
            }
        } catch (error) {
            console.error('Error checking subscription access:', error);
            navigate(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY);
        } finally {
            setIsCheckingAccess(false);
        }
    };

    return {
        isCheckingAccess,
        hasSubscriptionAccess
    };
};
